import { TemplatePage } from './types';

const live_streaming_nature_theme_page: TemplatePage = {
  header: {
    color: '#B3D1B5',
    icon: 'images/video-templates/nature-theme.jpg',
    title: 'Live Stream Templates — Nature Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Nature Theme',
    description_meta:
      'Make your live streams look more professional with Wave.video’s nature-themed overlay and transition screen video templates.',
    description:
      'Make your live streams look more professional with these nature-themed overlay and transition screen video templates. ' +
      'Step up your live streaming game with ease!'
  },
  footer: {
    category: 'Live streaming nature theme',
    description:
      'With Wave.video’s themed collections of ready-to-edit overlay and transition screen templates for live streaming, you ' +
      'will be able to take your live streams to the next level without much effort. Pick a template pack of your liking, ' +
      'easily customize it to your taste and needs, and wow your viewers during your next live stream. Easy and free!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Streaming Nature theme',
      search: { tags: 'NatureTheme' }
    },
    {
      type: 'stocks',
      title: 'nature',
      search: { name: 'nature' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_nature_theme_page;
